
export type BsSize = "xl" | "lg" | "md" | "sm" | "xs";
export type BsColor = "primary" | "secondary" | "success" | "info" | "warning" | "danger" | "light" | "dark";

export const KeyCodes = {
  backspace: 8,
  tab: 9,
  clear: 12, /*??*/
  enter: 13,
  esc: 27,
  space: 32,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46,
  numpadMinus: 109,
  minus: 189,
};
